import {createAccessControl} from "better-auth/plugins/access";
import {defaultStatements, adminAc} from "better-auth/plugins/admin/access";

/**
 * Custom permissions for the application
 *
 * Includes default better-auth admin statements plus custom ones:
 * - subscription: ["create", "list"]
 * - subscriptionPeriod: ["list", "update-limit"]
 * - plan: ["list"]
 * - organization: ["list", "create"]
 * - organizationMember: ["list", "create"]
 * - organizationSubscription: ["list", "create"]
 * - apiKey: ["list", "create", "read", "delete", "update"]
 */
export const statement = {
  ...defaultStatements,
  subscription: ["create", "list", "view", "changePlan"],
  subscriptionPeriod: ["list", "update-limit", "view"],
  plan: ["list"],
  organization: ["list", "create"],
  organizationMember: ["list", "create"],
  apiKey: ["list", "create", "read", "delete", "update"],
} as const;

export const ac = createAccessControl(statement);

/**
 * Admin role - full admin permissions plus custom ones
 */
export const admin = ac.newRole({
  ...adminAc.statements,
  subscription: ["create", "list", "view", "changePlan"],
  subscriptionPeriod: ["list", "update-limit", "view"],
  plan: ["list"],
  organization: ["list", "create"],
  organizationMember: ["list", "create"],
  apiKey: ["list", "create", "read", "delete", "update"],
});

/**
 * User role - basic permissions for standard users
 * Allows managing their own organizations and API keys
 */
export const user = ac.newRole({
  organization: ["list", "create"],
  organizationMember: ["list"],
  apiKey: ["list", "create", "read", "delete", "update"],
});
